export default __webpack_public_path__ + "static/media/022-canned sardine.2572b5d8.svg";